module.exports = __webpack_public_path__ + "static/media/confirm.82164054.svg";